export function fetchAudienceShoppingProductScopeData(resolve, serverContext) {
  return import(/* webpackChunkName: "eager" */ '@bingads-webui-campaign-react/product-services')
    .then(({ getProductScopeData }) => getProductScopeData(resolve, serverContext, {
      countryCode: 'US',
      getProductConditionOptions: true,
      getSalesCountryCollection: true,
      getDynamicDataFeedOptions: true,
      getCategoryFullData: true,
      getProductTypeFullData: true,
      dataName: 'AudienceMetaData',
      bypassCache: false,
      cacheResponse: true,
    }));
}
